<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import api from "./api/school"
export default {
  name: 'HomeView',
  components: {
  },
  data() {
    return {}
  },

  created() {
    var alink = window.location.href
    if (alink.indexOf('netschool') != -1) {
      var schoolId = alink.slice(alink.lastIndexOf('/') + 1, 99999)
      api.verifyChannel(schoolId).then(res => {
        localStorage.setItem('schoolId', res.data.data.id)
        sessionStorage.setItem('channel_info', JSON.stringify({
          channel_id: res.data.data.channelId
        }))
      })
    }
  },
  methods: {

  },
}
</script>
<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

* {
  margin: 0;
  padding: 0;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
